import React, { useState, useEffect, useContext, useMemo } from "react";
import { useTheme, alpha } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { jwtDecode } from "jwt-decode";
import {
  getCustomers,
  updateCustomer,
  getMyCustomers,
} from "../../api/Customer/customerApi";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";

import CustomerForm from "./CustomerForm";
import { customerMatchesSearch } from "./customerSearchUtils";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

import { SidebarContext } from "../Sidebar/SidebarProvider";

import { useTranslation } from "react-i18next";
import {
  pageFieldSx,
  pageHeroShellSx,
  pageMobileCardSx,
} from "../../styles/pageModernStyles";

const estados = [
  "New",
  "Ok Financiero",
  "Estudio Cliente",
  "Contactando",
  "Pain Presentación",
  "Muestra Interés",
  "En el Ring",
  "Esperando decisión",
  "Ganado",
  "Perdido",
  "Inactivo",
];

const responsables = [
  "Irene",
  "Lydia",
  "Imma",
  "Sara",
  "Agustina",
  "Laura",
  "Chiara",
  "Alex",
  "Borja",
  "Miguel",
  "Mikael",
];

const procedencias = ["Aotai", "HS Fashion", "No Man's Label", "Stage"];
const abcOptions = ["AA", "AB", "AC", "BA", "BB", "BC", "CA", "CB", "CC"];

const KanbanPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const { contentMargin } = useContext(SidebarContext);
  const accent = theme.palette.primary.main;
  const [filtersOpen, setFiltersOpen] = useState(false);

  const useStyles = makeStyles(() => ({
    kanbanContainer: {
      display: "flex",
      gap: "16px",
      overflowX: "auto",
      scrollSnapType: "x mandatory",
      scrollBehavior: "smooth",
      paddingBottom: "8px",
      WebkitOverflowScrolling: "touch",
    },
    kanbanColumn: {
      flex: "0 0 220px",
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100dvh - 220px)", // deja aire bajo la cabecera
      overflowY: "auto", // 👈 scroll vertical por columna
      padding: "0",
      scrollSnapAlign: "start",
      backgroundColor:
        theme.palette.mode === "dark"
          ? "  #313131 !important"
          : "#f4f4f4  !important",
      borderRadius: "4px",
    },
    kanbanCard: {
      padding: "12px",
      marginBottom: "8px",
      borderRadius: "8px",
    },
    avatarA: {
      backgroundColor: "rgb(0, 194, 163)",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "rgb(0, 194, 163)",
        border: "2px solid rgb(0, 194, 163)",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarB: {
      backgroundColor: "rgb(0, 194, 163)",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "rgb(0, 194, 163)",
        border: "2px solid rgb(0, 194, 163)",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarC: {
      backgroundColor: "#ffac7e",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "#ffac7e",
        border: "2px solid #ffac7e",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarD: {
      backgroundColor: "rgb(0, 194, 163)",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "rgb(0, 194, 163)",
        border: "2px solid rgb(0, 194, 163)",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarE: {
      backgroundColor: "#ffac7e",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "#ffac7e",
        border: "2px solid #ffac7e",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarF: {
      backgroundColor: "red",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "red",
        border: "2px solid red",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarG: {
      backgroundColor: "rgb(0, 194, 163)",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "rgb(0, 194, 163)",
        border: "2px solid rgb(0, 194, 163)",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarH: {
      backgroundColor: "red",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "red",
        border: "2px solid red",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },
    avatarI: {
      backgroundColor: "red",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "red",
        border: "2px solid red",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },

    avatarJ: {
      backgroundColor: "#3174ad",
      "&.MuiAvatar-circular": {
        backgroundColor: "transparent",
        color: "red",
        border: "2px solid red",
        fontWeight: "800",
        marginTop: ".3em",
      },
    },

    columnGanado: {
      color: "green",
    },
    columnPerdido: {
      color: "red",
    },
  }));
  const classes = useStyles();
  const [customers, setCustomers] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [selectedResponsables, setSelectedResponsables] = useState([]);
  const [selectedEstados, setSelectedEstados] = useState([]);
  const [selectedProcedencia, setSelectedProcedencia] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  /*   const [selectedDaysWithoutShipping, setSelectedDaysWithoutShipping] =
    useState(""); */

  /*   useEffect(() => {
    getMyCustomers().then((data) => {
      const groupedCustomers = estados.reduce((acc, estado) => {
        acc[estado] = data.filter((customer) => customer.estado === estado);
        return acc;
      }, {});
      setCustomers(groupedCustomers);
    });
  }, []); */

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const isAdmin = decoded.isAdmin;

      const data = isAdmin ? await getCustomers() : await getMyCustomers();

      const grouped = estados.reduce((acc, estado) => {
        acc[estado] = data.filter((customer) => customer.estado === estado);
        return acc;
      }, {});
      setCustomers(grouped);
    };

    fetchData();
  }, []);

  const onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;
    if (!destination) return;

    const sourceEstado = source.droppableId;
    const destEstado = destination.droppableId;

    if (sourceEstado === destEstado) return;

    const customer = customers[sourceEstado].find(
      (c) => c.id.toString() === draggableId
    );

    if (!customer) return;

    await updateCustomer(customer.id, { ...customer, estado: destEstado });

    const newSourceList = customers[sourceEstado].filter(
      (c) => c.id.toString() !== draggableId
    );
    const newDestList = [
      ...customers[destEstado],
      { ...customer, estado: destEstado },
    ];

    setCustomers((prevCustomers) => ({
      ...prevCustomers,
      [sourceEstado]: newSourceList,
      [destEstado]: newDestList,
    }));
  };

  const handleOpenDrawer = (customerId) => {
    setCurrentCustomerId(customerId);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setCurrentCustomerId(null);
  };

  const handleFormSubmit = async (customer) => {
    if (currentCustomerId) {
      await updateCustomer(currentCustomerId, customer);
    }
    handleCloseDrawer();
    getCustomers().then((data) => {
      const groupedCustomers = estados.reduce((acc, estado) => {
        acc[estado] = data.filter((customer) => customer.estado === estado);
        return acc;
      }, {});
      setCustomers(groupedCustomers);
    });
  };

  const getAvatarClass = (abc) => {
    switch (abc) {
      case "AA":
        return classes.avatarA;
      case "AB":
        return classes.avatarB;
      case "AC":
        return classes.avatarC;
      case "BA":
        return classes.avatarD;
      case "BB":
        return classes.avatarE;
      case "BC":
        return classes.avatarF;
      case "CA":
        return classes.avatarG;
      case "CB":
        return classes.avatarH;
      case "CC":
        return classes.avatarI;

      default:
        return "";
    }
  };

  const getResponsableAccent = (responsableVentas) => {
    switch (responsableVentas) {
      case "Irene":
        return "#2e7d32";
      case "Lydia":
        return "#c2185b";
      case "Imma":
        return "#0288d1";
      case "Sara":
        return "#5c6bc0";
      case "Agustina":
        return "#8d6e63";
      case "Laura":
        return "#78909c";
      case "Chiara":
        return "#7cb342";
      case "Alex":
        return "#ab47bc";
      case "Borja":
        return "#c62828";
      case "Miguel":
        return "#ef6c00";
      case "Mikael":
        return "#00695c";
      default:
        return theme.palette.text.secondary;
    }
  };

  const getResponsableChipSx = (responsableVentas) => {
    const color = getResponsableAccent(responsableVentas);
    return {
      height: 24,
      fontWeight: 700,
      fontSize: "0.72rem",
      bgcolor: alpha(color, 0.1),
      color,
      border: "1px solid",
      borderColor: alpha(color, 0.24),
    };
  };

  const getColumnClass = (estado) => {
    switch (estado) {
      case "Ganado":
        return classes.columnGanado;
      case "Perdido":
        return classes.columnPerdido;
      default:
        return "";
    }
  };

  const [selectedABC, setSelectedABC] = useState([]);
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredCustomers = () => {
    let filtered = Object.keys(customers).reduce((acc, estado) => {
      acc[estado] = customers[estado].filter((customer) =>
        customerMatchesSearch(customer, searchTerm),
      );
      return acc;
    }, {});

    // 🔹 Ocultar Ganado y Perdido por defecto si no hay filtro seleccionado
    if (selectedEstados.length === 0) {
      const { Ganado, Perdido, ...rest } = filtered;
      filtered = rest;
    }

    if (selectedResponsables.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, key) => {
        acc[key] = filtered[key].filter((customer) =>
          selectedResponsables.includes(customer.responsableVentas)
        );
        return acc;
      }, {});
    }

    if (selectedEstados.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, key) => {
        if (selectedEstados.includes(key)) {
          acc[key] = filtered[key];
        }
        return acc;
      }, {});
    }

    if (selectedProcedencia.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, key) => {
        acc[key] = filtered[key].filter((customer) =>
          selectedProcedencia.includes(customer.procedencia)
        );
        return acc;
      }, {});
    }

    if (selectedABC.length > 0) {
      filtered = Object.keys(filtered).reduce((acc, key) => {
        acc[key] = filtered[key].filter((customer) =>
          selectedABC.includes(customer.abc)
        );
        return acc;
      }, {});
    }

    return filtered;
  };

  const filterSurfaceBg =
    theme.palette.mode === "dark"
      ? theme.palette.background.cajaInpunts ||
        alpha(theme.palette.common.black, 0.35)
      : theme.palette.caja?.main || theme.palette.background.paper;

  const filterInputSx = {
    width: { xs: "100%", sm: 160, md: 172 },
    minWidth: 0,
    ...pageFieldSx(theme),
    "& .MuiInputBase-root": {
      ...pageFieldSx(theme)["& .MuiInputBase-root"],
      backgroundColor: filterSurfaceBg,
      color: theme.palette.text.primary,
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary,
    },
    "& .MuiSelect-icon, & .MuiSvgIcon-root": {
      color: theme.palette.text.secondary,
    },
  };

  const searchFieldSx = {
    ...filterInputSx,
    width: { xs: "100%", sm: 260, md: 300 },
  };

  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (selectedResponsables.length) count += 1;
    if (selectedEstados.length) count += 1;
    if (selectedProcedencia.length) count += 1;
    if (selectedABC.length) count += 1;
    return count;
  }, [selectedResponsables, selectedEstados, selectedProcedencia, selectedABC]);

  const visibleCustomers = useMemo(
    () => filteredCustomers(),
    [
      customers,
      searchTerm,
      selectedResponsables,
      selectedEstados,
      selectedProcedencia,
      selectedABC,
    ],
  );

  const totalCards = useMemo(
    () =>
      Object.values(visibleCustomers).reduce(
        (count, column) => count + column.length,
        0,
      ),
    [visibleCustomers],
  );

  const renderFilters = () => (
    <>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.AccManager")}</InputLabel>
        <Select
          multiple
          value={selectedResponsables}
          onChange={(e) => setSelectedResponsables(e.target.value)}
          label={t("Clientes.AccManager")}
          renderValue={(selected) => selected.join(", ")}
        >
          {responsables.map((responsable) => (
            <MenuItem key={responsable} value={responsable}>
              <Checkbox
                checked={selectedResponsables.indexOf(responsable) > -1}
              />
              <ListItemText primary={responsable} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.Origin")}</InputLabel>
        <Select
          multiple
          value={selectedProcedencia}
          onChange={(e) => setSelectedProcedencia(e.target.value)}
          label={t("Clientes.Origin")}
          renderValue={(selected) => selected.join(", ")}
        >
          {procedencias.map((procedencia) => (
            <MenuItem key={procedencia} value={procedencia}>
              <Checkbox
                checked={selectedProcedencia.indexOf(procedencia) > -1}
              />
              <ListItemText primary={procedencia} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.statement")}</InputLabel>
        <Select
          multiple
          value={selectedEstados}
          onChange={(e) => setSelectedEstados(e.target.value)}
          label={t("Clientes.statement")}
          renderValue={(selected) =>
            selected.map((estado) => t(`Clientes.${estado}`)).join(", ")
          }
        >
          {estados.map((estado) => (
            <MenuItem key={estado} value={estado}>
              <Checkbox checked={selectedEstados.indexOf(estado) > -1} />
              <ListItemText primary={t(`Clientes.${estado}`)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.ABC")}</InputLabel>
        <Select
          multiple
          value={selectedABC}
          onChange={(e) => setSelectedABC(e.target.value)}
          label={t("Clientes.ABC")}
          renderValue={(selected) => selected.join(", ")}
        >
          {abcOptions.map((abc) => (
            <MenuItem key={abc} value={abc}>
              <Checkbox checked={selectedABC.indexOf(abc) > -1} />
              <ListItemText primary={abc} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );

  const renderKanbanCard = (customer, provided) => {
    if (isMobile) {
      return (
        <Paper
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => handleOpenDrawer(customer.id)}
          sx={{
            ...pageMobileCardSx(theme, { accentColor: accent }),
            mb: 1,
            p: 1.25,
            cursor: "grab",
          }}
        >
          <Stack direction="row" spacing={1} alignItems="flex-start">
            <Avatar
              className={getAvatarClass(customer?.abc || "")}
              sx={{ width: 34, height: 34, m: 0 }}
            >
              {customer?.abc || "?"}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 800, lineHeight: 1.25, fontSize: "0.9rem" }}>
                {customer.name}
              </Typography>
              {customer.email ? (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {customer.email}
                </Typography>
              ) : null}
              {customer.responsableVentas ? (
                <Chip
                  size="small"
                  label={customer.responsableVentas}
                  sx={{ mt: 0.6, ...getResponsableChipSx(customer.responsableVentas) }}
                />
              ) : null}
            </Box>
          </Stack>
        </Paper>
      );
    }

    return (
      <Tooltip
        title={
          customer.observaciones ? customer.observaciones : "Sin observaciones"
        }
        arrow
      >
        <Paper
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          elevation={0}
          sx={{
            p: 1.25,
            mb: 1,
            borderRadius: 2,
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.75),
            bgcolor: theme.palette.background.paper,
            boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.05)}`,
            "&:hover": {
              borderColor: alpha(accent, 0.35),
              boxShadow: `0 4px 12px ${alpha(accent, 0.1)}`,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 1,
            }}
          >
            <Typography sx={{ fontWeight: 800, minWidth: 0, fontSize: "0.88rem", lineHeight: 1.25 }}>
              {customer.name}
            </Typography>
            <Avatar className={getAvatarClass(customer?.abc || "")} sx={{ width: 32, height: 32, m: 0 }}>
              {customer?.abc || "?"}
            </Avatar>
          </Box>
          {customer.email ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
                fontSize: "0.78rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {customer.email}
            </Typography>
          ) : null}
          {customer.phone ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
              {customer.phone}
            </Typography>
          ) : null}
          <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap" sx={{ mt: 0.75 }}>
            {customer.ingresos_estimados ? (
              <Chip
                size="small"
                label={`Income: ${customer.ingresos_estimados}`}
                sx={{
                  height: 22,
                  fontSize: "0.68rem",
                  fontWeight: 600,
                  bgcolor: alpha(theme.palette.background.default, 0.8),
                }}
              />
            ) : null}
            {customer.responsableVentas ? (
              <Chip
                size="small"
                label={customer.responsableVentas}
                sx={getResponsableChipSx(customer.responsableVentas)}
              />
            ) : null}
          </Stack>
          <Button
            size="small"
            onClick={() => handleOpenDrawer(customer.id)}
            sx={{
              border: "1px solid",
              borderColor: alpha(accent, 0.3),
              color: "text.secondary",
              width: "100%",
              mt: 1,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Edit
          </Button>
        </Paper>
      </Tooltip>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        pt: 2,
        pl: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, md: 3 },
        pb: { xs: 10, sm: 2 },
        ...contentMargin,
      }}
    >
      <Box sx={pageHeroShellSx(theme, { sticky: !isMobile })}>
        <Box sx={{ p: { xs: 1.25, sm: 1.75 } }}>
          <Stack
            direction={{ xs: "column", lg: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", lg: "flex-start" }}
            spacing={1.5}
          >
            <Stack direction="row" spacing={1.25} alignItems="flex-start">
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(accent, theme.palette.mode === "dark" ? 0.22 : 0.16),
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : theme.palette.primary.dark,
                  border: "1px solid",
                  borderColor: alpha(accent, 0.28),
                }}
              >
                <ViewKanbanOutlinedIcon fontSize="small" />
              </Box>
              <Box>
                <Typography
                  variant="overline"
                  color="text.secondary"
                  sx={{ fontWeight: 700, letterSpacing: 1.1 }}
                >
                  CRM
                </Typography>
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  sx={{ fontWeight: 800, lineHeight: 1.1 }}
                >
                  {t("sidebar.kanbanClients")}
                </Typography>
                <Chip
                  size="small"
                  label={`${totalCards} ${t("sidebar.clients", { defaultValue: "clientes" }).toLowerCase()}`}
                  sx={{
                    mt: 0.75,
                    fontWeight: 700,
                    bgcolor: alpha(accent, theme.palette.mode === "dark" ? 0.18 : 0.1),
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.primary.main
                        : theme.palette.primary.dark,
                    border: "1px solid",
                    borderColor: alpha(accent, 0.28),
                  }}
                />
              </Box>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
              alignItems="center"
              sx={{ width: { xs: "100%", lg: "auto" } }}
            >
              <TextField
                label={t("Clientes.search")}
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={searchFieldSx}
              />
              {isMobile ? (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<FilterListOutlinedIcon />}
                  onClick={() => setFiltersOpen((open) => !open)}
                  sx={{ fontWeight: 700, textTransform: "none" }}
                >
                  {t("Clientes.filters", { defaultValue: "Filtros" })}
                  {activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}
                </Button>
              ) : null}
            </Stack>
          </Stack>

          <Collapse in={!isMobile || filtersOpen}>
            <Box
              sx={{
                mt: 1.5,
                display: "flex",
                flexWrap: "wrap",
                gap: 1.25,
                alignItems: "center",
              }}
            >
              {renderFilters()}
            </Box>
          </Collapse>

          {isMobile ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 1, fontWeight: 600 }}
            >
              {t("kanban.swipeHint", {
                defaultValue: "Desliza horizontalmente para ver cada estado.",
              })}
            </Typography>
          ) : null}
        </Box>
      </Box>

      <DragDropContext onDragEnd={onDragEnd}>
        <Box
          className={classes.kanbanContainer}
          sx={{
            flex: 1,
            minHeight: 0,
            gap: { xs: 1, md: 2 },
            px: { xs: 0.25, md: 0 },
            scrollSnapType: "x mandatory",
          }}
        >
          {Object.keys(visibleCustomers).map((estado) => (
            <Droppable key={estado} droppableId={estado}>
              {(provided) => (
                <Box
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={classes.kanbanColumn}
                  sx={{
                    flex: { xs: "0 0 86vw", sm: "0 0 72vw", md: "0 0 220px" },
                    maxWidth: { xs: 360, md: 220 },
                    maxHeight: {
                      xs: "calc(100dvh - 260px)",
                      md: "calc(100dvh - 220px)",
                    },
                    borderRadius: 2.5,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? theme.palette.background.paper
                        : alpha(theme.palette.background.default, 0.7),
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 800,
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      backgroundColor: alpha(theme.palette.primary.main, 0.08),
                      px: 1,
                      py: 0.85,
                      textAlign: "center",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                    className={getColumnClass(estado)}
                  >
                    {t(`Clientes.${estado}`)}
                    <Box
                      component="span"
                      sx={{
                        ml: 0.75,
                        opacity: 0.7,
                        fontWeight: 700,
                        fontSize: "0.75rem",
                      }}
                    >
                      ({visibleCustomers[estado]?.length || 0})
                    </Box>
                  </Typography>
                  <Box sx={{ p: { xs: 0.75, md: 0.5 }, pt: 0.75 }}>
                    {visibleCustomers[estado]?.map((customer, index) => (
                      <Draggable
                        key={customer.id}
                        draggableId={customer.id.toString()}
                        index={index}
                      >
                        {(dragProvided) => renderKanbanCard(customer, dragProvided)}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                </Box>
              )}
            </Droppable>
          ))}
        </Box>
      </DragDropContext>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.75),
            maxWidth: "100vw",
            boxShadow: `0 24px 64px ${alpha(theme.palette.common.black, 0.16)}`,
            bgcolor: theme.palette.background.default,
          },
        }}
      >
        <Box
          sx={{
            width: { xs: "100vw", sm: "100vw", md: 1000, lg: 1830 },
            maxWidth: "100vw",
            p: 0,
            minHeight: { xs: "100dvh", md: "auto" },
          }}
        >
          <CustomerForm
            customerId={currentCustomerId}
            onSubmit={handleFormSubmit}
            onClose={handleCloseDrawer}
          />
        </Box>
      </Drawer>
    </Box>
  );
};

export default KanbanPage;
